import { render } from "./BulletList.vue?vue&type=template&id=d789f882&scoped=true"
import script from "./BulletList.vue?vue&type=script&lang=js"
export * from "./BulletList.vue?vue&type=script&lang=js"

import "./BulletList.vue?vue&type=style&index=0&id=d789f882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d789f882"]])

export default __exports__